<template>
  <div class="menu">
    <ul>

      <li class="logo">
        <img :src="logo">
      </li>

      <router-link tag="li" :to="'/login'" v-if="!authCheck" @click="" class="active">
        <a>
          <span>Login</span>
        </a>
      </router-link>

      <router-link :key="link.name" v-for="link in links" v-if="link.show" :to="{ name: link.route }" tag="li" activeClass="active">
        <a>
          {{ link.name }}
        </a>
      </router-link>

      <li v-if="authCheck" @click="logout">
        <a>
          <span>Logout</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  created() {
    this.links = [
      {
        name: 'Agenda',
        route: 'agenda.index',
        show: this.authCheck,
      },
      {
        name: 'Resources',
        route: 'users.index',
        show: this.authCheck && this.isAdmin,
      },
      {
        name: 'Clients',
        route: 'clients.index',
        show: this.authCheck && !this.isSimple,
      },
      {
        name: 'Account',
        route: 'account.index',
        show: this.authCheck,
      },
      {
        name: 'Exports',
        route: 'exports.index',
        show: this.authCheck && this.isAdmin
      },

      // {
      //   name: 'Reports',
      //   route: 'reports.index',
      //   show: this.authCheck && this.isAdmin,
      // },
      // {
      //   name: 'Financial Reports',
      //   route: 'financialReports.index',
      //   show: this.authCheck && this.isAdmin,
      // },
      {
        name: 'Invoices',
        route: 'invoices2.index',
        show: this.authCheck && this.isAdmin,
      },
      {
        name: 'Config',
        route: 'config.index',
        show: this.authCheck && this.isAdmin,
      },
    ]
  },
  mounted() {
    // hide sidebar when clicked on menu item @small screens
    document.querySelectorAll('.m-menu__link').forEach(el => {
      el.addEventListener('click', e => {
        const el = document.querySelector('.m-aside-left-overlay')
        if (el) {
          el.click()
        }
      })
    })
  },
  data() {
    return {
      links: [],
      logo: require('./../../static/logo.svg')
    }
  },
  computed: {
    ...mapGetters('auth', ['authCheck', 'isAdmin', 'isSimple'])
  },
  methods: {
    ...mapActions('auth', ['logout'])
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue